import { useState } from 'react';
import {
  FieldErrorsImpl,
  UseFormClearErrors,
  UseFormRegister,
  UseFormResetField,
  UseFormSetError,
  UseFormSetValue,
} from 'react-hook-form';
import { imgUrl } from '../../Helpers/Constant';

type IProps = {
  label: string;
  onChange?: (value: any) => void;
  register: UseFormRegister<any>;
  setError?: UseFormSetError<any>;
  clearErrors?: UseFormClearErrors<any>;
  setValue?: UseFormSetValue<any>;
  resetField?: UseFormResetField<any>;
  errors?: any;
  fileName: string;
  required?: boolean;
  fullImageUrl?: boolean;
  offLabel?: boolean;
  defaultValue?: string | null;
  uploadBtnName?: string;
  fileSize?: number;
};
const CommonImageUpload = ({
  label,
  onChange,
  register,
  setError,
  setValue,
  resetField,
  clearErrors,
  fileName,
  errors,
  required,
  defaultValue,
  fullImageUrl,
  uploadBtnName,
  offLabel,
  fileSize,
}: IProps) => {
  const [profilePhoto, setProfilePhoto] = useState<any>('');
  return (
    <div className='row'>
      {!offLabel && (
        <label>
          {label}
          {required && <span className='require'>*</span>}
        </label>
      )}

      <div className='companies-logo-card'>
        <div className='img-thumbnail' style={{ width: 'w-100' }}>
          {profilePhoto ? (
            <div style={{ textAlign: 'center' }}>
              <img
                style={{
                  width: '200px',
                  height: '150px',
                }}
                className='ls-is-cached lazyloaded'
                id='uploadedImage'
                src={URL.createObjectURL(profilePhoto)}
                alt=''
              />
            </div>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <img
                style={{
                  width: '200px',
                  height: '150px',
                  objectFit: 'contain',
                }}
                className='ls-is-cached lazyloaded'
                id='uploadedImage'
                src={
                  defaultValue
                    ? fullImageUrl
                      ? defaultValue
                      : imgUrl + '/' + defaultValue
                    : '/assets/image.png'
                }
                alt=''
              />
            </div>
          )}
        </div>

        <div>
          <input
            {...(fileName
              ? register(fileName, {
                  required: required ? 'File is required' : false,
                  onChange: (e) => {
                    const file = e.target.files[0];
                    const defaultSize = 5;
                    if (file) {
                      const maxSize = (fileSize || defaultSize) * 1024 * 1024;
                      const bufferSize = 2449;
                      if (file.size > maxSize + bufferSize) {
                        setError?.(fileName, {
                          type: 'manual',
                          message: `File size should not exceed ${
                            fileSize || defaultSize
                          } MB`,
                        });
                      } else {
                        clearErrors?.(fileName); // Clear previous errors if the file is valid
                        setProfilePhoto(file);
                        onChange && onChange(file);
                      }
                    }
                    // setProfilePhoto(e.target.files[0]);
                    // onChange && onChange(e.target.files[0]);
                  },
                })
              : {})}
            type='file'
            id={label}
            accept='image/jpg, image/png, image/jpeg'
            hidden
            // onChange={(e: any) => {
            //   console.log(e, e.target.files?.length);

            //   setProfilePhoto(e.target.files[0]);
            //   onChange && onChange(e.target.files[0]);

            //   if (e.target.files[0] && fileName) {
            //     console.log('Upload', errors);
            //     setValue && fileName && setValue(fileName, 'ddd');
            //     clearErrors && clearErrors(fileName);
            //   }
            // }}
          />

          <label
            htmlFor={label}
            className='upload-visitor-image-btn text-center w-100'
          >
            {uploadBtnName || 'Upload photo'}{' '}
            <span className='text-danger'>(Max 5 mb)</span>
          </label>
          <p>
            {fileName && errors && errors[fileName]?.message && (
              <span className='text-danger'>{errors[fileName]?.message}</span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CommonImageUpload;
